import { Box, Button, TextField, useMediaQuery } from "@mui/material";
import React from "react";

import { useNavigate, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import axios from "axios";
import { toast } from "react-toastify";
// import { useLocation } from 'react-router-dom';
import { useAuth } from "../Context/AuthContext";
import CloseIcon from "@mui/icons-material/Close";
const apiUrl = process.env.REACT_APP_API_REST_URL;

const Referraldetails = () => {
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const location = useLocation();
  const clientId = location.state?.clientId;

  const { token } = useAuth();
  const navigate = useNavigate();
  // const location = useLocation();
  // const userId = location.userId?.userId;
  // console.log("userid",userId)
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "onTouched" });

  const onSubmit = async (data) => {
    const headers = {
      "x-access-token": token,
    };
    // console.log('UserId from prop:', userId);

    try {
      // Example update request
      const updateResponse = await axios.put(
        `${apiUrl}/CCE/api/v1/referalEngine/updateReferral`,
        {
          ...data, // Spread the existing data
          referredId: clientId,
        },
        { headers }
      );

      console.log("updateResponseeeee", updateResponse);

      if (updateResponse) {
        toast.success("Referral details added successfully!");
        // Access the 'id' property from the response
        // navigate("/agreement", { state: { userId } });
        setTimeout(() => {
          // Navigate to the next page
          navigate("/dashboard");
        }, 2000);
        // return <Referraldetails userId={userId}/>
      }
      // id: userId,

      console.log("Update Response:", updateResponse.data);

      // Navigate to the "Thank You" page on successful agreement
    } catch (error) {
      console.error("Error updating user:", error.message);
      toast.error("Network error. Please try again.");
      // Handle the error appropriately
    }
    // console.log(data); // Perform any additional actions here
  };

  // const handleSubmit = () => {
  //   navigate("/partnerdashboard");
  // }

  const handleCancel = () => {
    navigate("/dashboard");
    // console.log("Run handle cancel");
  };

  return (
    <>
      {isSmallScreen ? (
        <span>
          <Box sx={styles.formboxres}>
            <Box
              onClick={handleCancel}
              sx={{
                textAlign: "right",
                cursor: "pointer",
                color: "#666666",
              }}
            >
              <CloseIcon />
            </Box>
            <h3>Referral Details</h3>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Box sx={{ marginTop: "12px" }}>
                <TextField
                  {...register("location", {
                    required: "Location is required",
                  })}
                  sx={styles.textfieldres}
                  id="outlined-basic"
                  label="Location"
                  variant="outlined"
                />
                {errors.location && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      textAlign: "left",
                      marginLeft: "10px",
                    }}
                  >
                    {errors.location.message}
                  </div>
                )}
              </Box>
              <Box sx={{ marginTop: "12px" }}>
                <TextField
                  {...register("automobileOwned", {
                    required: "Automobile owned is required",
                  })}
                  sx={styles.textfieldres}
                  id="outlined-basic"
                  label="Automobile owned"
                  variant="outlined"
                />
                {errors.automobileOwned && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      textAlign: "left",
                      marginLeft: "10px",
                    }}
                  >
                    {errors.automobileOwned.message}
                  </div>
                )}
              </Box>
              <Box sx={{ marginTop: "12px" }}>
                <TextField
                  {...register("clubMembership", {
                    required: "Club membership is required",
                  })}
                  sx={styles.textfieldres}
                  id="outlined-basic"
                  label="Club membership"
                  variant="outlined"
                />
                {errors.clubMembership && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      textAlign: "left",
                      marginLeft: "10px",
                    }}
                  >
                    {errors.clubMembership.message}
                  </div>
                )}
              </Box>
              <Box sx={{ marginTop: "12px" }}>
                <TextField
                  {...register("description", {
                    required: "Tell us about the referral is required",
                  })}
                  sx={styles.textfieldres}
                  id="outlined-basic"
                  label="Tell us good about the referral"
                  variant="outlined"
                />
                {errors.description && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      textAlign: "left",
                      marginLeft: "10px",
                    }}
                  >
                    {errors.description.message}
                  </div>
                )}
              </Box>
              <Button type="submit" sx={styles.btn}>
                Submit
              </Button>
            </form>
          </Box>
        </span>
      ) : (
        <span>
          <Box sx={styles.formbox}>
            <Box
              onClick={handleCancel}
              sx={{
                textAlign: "right",
                cursor: "pointer",
                color: "#666666",
              }}
            >
              <CloseIcon />
            </Box>
            <h3>Referral Details</h3>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Box sx={{ marginTop: "12px" }}>
                <TextField
                  {...register("location", {
                    required: "Location is required",
                  })}
                  sx={styles.textfield}
                  id="outlined-basic"
                  label="Location"
                  variant="outlined"
                />
                {errors.location && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      textAlign: "left",
                      marginLeft: "10px",
                    }}
                  >
                    {errors.location.message}
                  </div>
                )}
              </Box>
              <Box sx={{ marginTop: "12px" }}>
                <TextField
                  {...register("automobileOwned", {
                    required: "Automobile owned is required",
                  })}
                  sx={styles.textfield}
                  id="outlined-basic"
                  label="Automobile owned"
                  variant="outlined"
                />
                {errors.automobileOwned && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      textAlign: "left",
                      marginLeft: "10px",
                    }}
                  >
                    {errors.automobileOwned.message}
                  </div>
                )}
              </Box>
              <Box sx={{ marginTop: "12px" }}>
                <TextField
                  {...register("clubMembership", {
                    required: "Club membership is required",
                  })}
                  sx={styles.textfield}
                  id="outlined-basic"
                  label="Club membership"
                  variant="outlined"
                />
                {errors.clubMembership && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      textAlign: "left",
                      marginLeft: "10px",
                    }}
                  >
                    {errors.clubMembership.message}
                  </div>
                )}
              </Box>
              <Box sx={{ marginTop: "12px" }}>
                <TextField
                  {...register("description", {
                    required: "Tell us about the referral is required",
                  })}
                  sx={styles.textfield}
                  id="outlined-basic"
                  label="Tell us good about the referral"
                  variant="outlined"
                />
                {errors.description && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      textAlign: "left",
                      marginLeft: "10px",
                    }}
                  >
                    {errors.description.message}
                  </div>
                )}
              </Box>
              <Button type="submit" sx={styles.btn}>
                Submit
              </Button>
            </form>
          </Box>
        </span>
      )}
    </>
  );
};

export default Referraldetails;

const styles = {
  formbox: {
    position: "absolute",
    top: "51.5%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "15px",
    background: "#FFFFFF",
    borderRadius: "8px",
    textAlign: "center",
    // height:"420px",
    width: "420px",
  },
  formboxres: {
    position: "absolute",
    top: "51.5%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "15px",
    background: "#FFFFFF",
    borderRadius: "8px",
    textAlign: "center",
    // height:"420px",
    width: "320px",
  },
  formboxtwo: {
    position: "absolute",
    top: "82%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "20px",
    background: "#FFFFFF",
    borderRadius: "8px",
    textAlign: "center",
    height: "30px",
    width: "520px",
  },
  btn: {
    margin: "2em 0em 2em 0em",
    width: "12em",
    backgroundColor: "#002C51",
    color: "white",
    textTransform: "none",
    "&:hover": {
      background: "#002C51",
    },
  },
  textfield: {
    width: "420px",
  },
  textfieldres: {
    width: "300px",
  },
};
